import React, { useState } from "react";
import { StyleSheet, View } from "react-native";

import { AttributeCardDisplayVariantType, AttributeCardType } from "../types";

import AttributeCard from "@/Components/PersonalAttributes/Components/AttributeCard";
import { type AppUserSession } from "@/schemas/auth/session";
import { UserAttributeType } from "@/schemas/profile/UserAttributeSet";
import ProfileService from "@/services/user/profile";
import { dateToString, stringToDate } from "@/utils/datetime";
import DatePicker from "@/Components/PersonalAttributes/Components/Modal/DatePicker";

type BirthdayProps = {
  session: AppUserSession;
  birthdayStr: string | null;
  variant: AttributeCardDisplayVariantType;
};

function calculateDateLimit(offset: number): Date {
  const today = new Date();
  return new Date(
    today.getFullYear() - offset,
    today.getMonth(),
    today.getDate(),
  );
}

function Birthday({
  session,
  birthdayStr,
  variant,
}: BirthdayProps): React.JSX.Element {
  const [showModal, setShowModal] = useState(false);
  const isAccountScreen = variant === AttributeCardDisplayVariantType.ACCOUNT;

  const [birthday, setBirthday] = useState<Date | null>(
    birthdayStr ? stringToDate(birthdayStr) : null,
  );

  const handleSave = async (newDate: Date | null): Promise<void> => {
    if (newDate) {
      try {
        const profileService = new ProfileService(session);
        await profileService.updateAttributes(UserAttributeType.BIRTHDAY, [
          dateToString(newDate),
        ]);
      } catch (error) {
        alert(error);
      }
      setBirthday(newDate);
    }
    setShowModal(false);
  };

  return (
    <View
      style={[
        styles.container,
        isAccountScreen ? styles.containerHalfWidth : styles.containerFullWidth,
      ]}
    >
      <AttributeCard
        attributeType={AttributeCardType.DATE_PICKER}
        attributeId={UserAttributeType.BIRTHDAY}
        values={[
          {
            id: UserAttributeType.BIRTHDAY,
            label: birthday ? dateToString(birthday) : "",
            iconLabel: "",
          },
        ]}
        onPress={() => setShowModal(true)}
        icon={"🎂"}
        isDisabled={false}
        variant={variant}
      />
      <DatePicker
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        handleSave={handleSave}
        initialDate={birthday}
        minDate={calculateDateLimit(100)}
        maxDate={calculateDateLimit(18)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  containerHalfWidth: {
    width: "48%",
  },
  containerFullWidth: {
    width: "100%",
  },
});

export default Birthday;
